module.exports = __webpack_public_path__ + "static/kdb-banner-2-8a897310bc763f0d87114fee6ae647a8.png";